import * as React from "react";
import { memo } from "react";
const SvgCaret = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 12, viewBox: "0 0 13 12", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.5 9L1.5 4H11.5L6.5 9Z", fill: "currentColor" }));
const Memo = memo(SvgCaret);
export default Memo;
